import { render, staticRenderFns } from "./AlunosContaGoogle.vue?vue&type=template&id=0a4a2966&"
import script from "./AlunosContaGoogle.vue?vue&type=script&lang=js&"
export * from "./AlunosContaGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports